import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { parse } from 'query-string';

import { apiFetchBase } from 'src/core/fetch';
import { fetchCatch } from 'src/core/sentry';
import type { User } from 'src/types/user/User';

export type UseApproveCaptain = {
  userDetails: Partial<User>;
};

const getUserDetailsFromHashedIdParam = async (hashedId: string) => {
  const res = await apiFetchBase(
    `/boats/approve_captain/${hashedId}/`,
    { method: 'PATCH' },
  );
  const data = await res.json();

  return {
    email: data.email,
    first_name: data.first_name,
    last_name: data.last_name,
    phone: data.phone,
    user_id: data.captain_id,
  };
};

/**
 * Returns the user's details from the `/boats/approve_captain/` endpoint
 */
const useApproveCaptain = (): UseApproveCaptain => {
  const { search } = useLocation();
  const { hashedId } = parse(search);
  const [userDetails, setUserDetails] = useState<Partial<User>>({});

  useEffect(() => {
    if (hashedId && typeof hashedId === 'string') {
      getUserDetailsFromHashedIdParam(hashedId)
        .then(async (data) => {
          setUserDetails(data);
        })
        .catch(fetchCatch);
    }
  }, [hashedId]);

  return {
    userDetails,
  };
};

export default useApproveCaptain;
